var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91304 2C3.91304 3.10457 3.03708 4 1.95652 4C0.875965 4 0 3.10457 0 2C0 0.895431 0.875965 0 1.95652 0C3.03708 0 3.91304 0.895431 3.91304 2Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 2C10.9565 3.10457 10.0806 4 9 4C7.91944 4 7.04348 3.10457 7.04348 2C7.04348 0.895431 7.91944 0 9 0C10.0806 0 10.9565 0.895431 10.9565 2Z",
    fill: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2C18 3.10457 17.124 4 16.0435 4C14.9629 4 14.087 3.10457 14.087 2C14.087 0.895431 14.9629 0 16.0435 0C17.124 0 18 0.895431 18 2Z",
    fill: "#A4A4A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEllipsis);
export default __webpack_public_path__ + "static/media/icon-ellipsis.680b665a93e6128446a437aaf411f9b2.svg";
export { ForwardRef as ReactComponent };